import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import * as actions from '../../../../store/actions';
import Table from '../../../UI/Table/Table';
import { MTableHeader } from 'material-table';
import { storageMonedaSigno } from '../../../../shared/sessionData';
import { formatNumber } from '../../../../shared/formatNumber';
import ModalDetallesComprobante from '../ModalDetallesComprobante/ModalDetallesComprobante';

const TableComprobantesVentasDeLaSucursalDelArticuloAlCliente = (props) => {
  const [comprobantesState, setComprobantesState] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const mes = props.mes;
    const anio = props.anio;
    props.onLoadComprobantes(
      mes,
      anio,
      props.sucursalId,
      props.articuloId,
      props.clienteId,
      (comprobantes) => {
        setComprobantesState(comprobantes);
        setLoading(false);
      },
      () => {
        setComprobantesState([]);
        setLoading(false);
      }
    );
  }, []);

  const cellStyles = {
    fontSize: 'smaller',
    paddingBottom: '0px',
    paddingTop: '0px',
    paddingLeft: '5px',
    paddingRight: '5px'
  };
  const headerStyles = {
    fontSize: 'small',
    paddingTop: '0px',
    paddingBottom: '0px',
    backgroundColor: 'rgb(205, 205, 205)',
    paddingLeft: '5px',
    paddingRight: '5px'
  };

  const columns = [
    {
      title: 'Fecha',
      field: 'fecha',
      align: 'left',
      width: 10,
      cellStyle: cellStyles,
      headerStyle: headerStyles,
      render: (rowData) => `${moment(rowData.fecha).format('DD/MM/YY')}`
    },
    {
      title: 'Comprobante',
      field: 'comprobante',
      align: 'left',
      cellStyle: cellStyles,
      headerStyle: headerStyles
    },
    {
      title: 'Ref.',
      field: 'referencia',
      align: 'left',
      cellStyle: cellStyles,
      headerStyle: headerStyles
    },
    {
      title: 'Num. Externo',
      field: 'numeroExterno',
      align: 'left',
      cellStyle: cellStyles,
      headerStyle: headerStyles
    },
    {
      title: 'Importe',
      field: 'monto',
      align: 'right',
      cellStyle: (cellData) => {
        return {
          ...cellStyles,
          color: cellData < 0 && 'red'
        };
      },
      headerStyle: headerStyles,
      render: (rowData) => `${storageMonedaSigno()} ${formatNumber(rowData.monto)}`
    },
    {
      title: 'Ver',
      field: 'id',
      align: 'center',
      cellStyle: cellStyles,
      headerStyle: headerStyles,
      render: (rowData) => {
        return <ModalDetallesComprobante venta comprobante={{ ...rowData, nombreComprobante: rowData.comprobante }} />;
      }
    }
  ];

  const data = () => {
    return comprobantesState.map((comprobante) => ({
      idComproba: comprobante.idComproba,
      idSistema: comprobante.idSistema,
      idSucursal: comprobante.idSucursal,
      fecha: comprobante.fecha,
      comprobante: comprobante.comprobante,
      referencia: comprobante.referencia,
      numeroExterno: comprobante.numeroExterno,
      monto: comprobante.monto
    }));
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
      }}
    >
      <Table
        style={{ width: props.customWidth ? props.customWidth : '100%', marginTop: 0, marginBottom: '15px' }}
        columns={columns}
        data={data()}
        noBoxShadow
        loading={loading}
        components={{
          Header: (props) => (
            <MTableHeader {...props}>
              {(props.columns[0].tableData.width = '20px')}
              {(props.columns[1].tableData.width = '250px')}
              {(props.columns[2].tableData.width = '20px')}
              {(props.columns[3].tableData.width = window.screen.width > 1600 ? ' 175px' : '165px')}
              {(props.columns[4].tableData.width = window.screen.width > 1600 ? ' 100px' : '135px')}
              {(props.columns[5].tableData.width = '35px')}
            </MTableHeader>
          )
        }}
        customOptions={{
          actionsColumnIndex: -1,
          grouping: false,
          draggable: false,
          toolbar: false,
          showTitle: false,
          detailPanelType: 'single',
          detailPanelColumnAlignment: 'right',
          paging: false,
          maxBodyHeight: 200
        }}
        tableKey={"tabla-comprobantes-ventas-sucursal-articulo-cliente"}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadComprobantes: (mes, anio, sucursalId, articuloId, clienteId, success, failError) =>
      dispatch(
        actions.loadVentasDeLaSucursalDelArticuloAlCliente(
          mes,
          anio,
          sucursalId,
          articuloId,
          clienteId,
          success,
          failError
        )
      )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TableComprobantesVentasDeLaSucursalDelArticuloAlCliente);
